import { Http } from "@/plugins/http";
import { CustomerDiseasesRepository } from "@/modules/diseases/customer-diseases.repository.js";

export class CustomerService {
  /**
   *
   * @param {number} id
   * @return Promise<CustomerProfile>
   */
  static getProfile(id) {
    return Http.get(`v1/customers/${id}`).then(response => response.data.data);
  }

  /**
   * Удаление симптома пациента
   *
   * @param {number} customerId
   * @param {number} symptomId
   * @return {Promise<*>}
   */
  static removeSymptom(customerId, symptomId) {
    return Http.delete(`v1/customers/${customerId}/symptoms/${symptomId}`).then(response => response.data);
  }

  /**
   * Возвращает модель аллергии
   * @return Promise<any, Allergy>
   */
  static getAllergy(customerId, allergyId) {
    return Http.get(`v1/customers/${customerId}/allergies/${allergyId}`, { params: { lang: "ru" } }).then(
      response => response.data.data,
    );
  }

  /**
   * Удаление аллергии пациента
   *
   * @param {number} customerId
   * @param {number} allergyId
   * @return {Promise<*>}
   */
  static removeAllergy(customerId, allergyId) {
    return Http.delete(`v1/customers/${customerId}/allergies/${allergyId}`).then(response => response.data);
  }

  /**
   * Удаление лекарства
   *
   * @param {number} customerId
   * @param {number} drugId
   * @param {number|string|null} doctorId
   * @return {Promise<*>}
   */
  static removeDrug(customerId, drugId, doctorId = "") {
    return Http.delete(`v1/customers/${customerId}/medicines/${drugId}?doctor_id=${doctorId}`).then(response => response.data);
  }

  /**
   * Удаление рейепта
   *
   * @param {number} customerId
   * @param {number} drugId
   * @param {number|string|null} doctorId
   * @return {Promise<*>}
   */
  static removeReciept(customerId, drugId) {
    return Http.delete(`v1/customers/${customerId}/drugs/${drugId}`).then(response => response.data);
  }

  /**
   * Удаление докуменетов
   *
   * @param {number} customerId
   * @param {number} documentId
   * @return {Promise<*>}
   */
  static removeDocument(customerId, documentId) {
    return Http.delete(`v1/customers/${customerId}/documents/${documentId}`).then(response => response.data);
  }

  /**
   * Удаление докуменетов
   *
   * @param {number} customerId
   * @param {number} parametersId
   * @return {Promise<*>}
   */
  static removeParameter(customerId, parametersId) {
    return Http.delete(`v1/customers/${customerId}/documents/${parametersId}`).then(response => response.data);
  }

  /**
   * Удаляет заболевания пациента
   * @param {number} customerId
   * @param {number} diseaseId
   * @return {Promise<*>}
   */
  static removeDiseases(customerId, diseaseId) {
    return CustomerDiseasesRepository.removeById(customerId, diseaseId);
  }

  /**
   * Возвращает модель заболевания
   * @return Promise<Disease>
   */
  static getDisease(customerId, diseaseId) {
    return CustomerDiseasesRepository.getById(customerId, diseaseId);
  }

  /**
   * Возвращает модель симптома
   * @return Promise<Symptom>
   */
  static getSymptom(customerId, symptomId) {
    return Http.get(`v1/customers/${customerId}/symptoms/${symptomId}`, { params: { lang: "ru" } }).then(
      response => response.data.data,
    );
  }

  /**
   * Возвращает документ пользователя
   * @return Promise<any, CustomerDocument>
   */
  static getDocument(customerId, docId) {
    return Http.get(`v1/customers/${customerId}/documents/${docId}`, { params: { lang: "ru" } }).then(
      response => response.data.data,
    );
  }

  /**
   * Возвращает измерения по параметра за указанный день
   * @return Promise<any, CustomerParameterMeasurementItem[]>
   */
  static getParameterMeasurementsForDay(customerId, paramId, date) {
    return Http.get(`v1/customers/${customerId}/params/${paramId}/measurements`, {
      params: { lang: "ru", date: date },
    }).then(response => response.data.data);
  }

  /**
   * Возвращает измерения по параметрам
   * @return Promise<any, CustomerParameterMeasurementItem[]>
   */
  static getParameterMeasurementsForChart(customerId, paramId) {
    return Http.get(`v1/customers/${customerId}/params/${paramId}/history`, {
      params: { lang: "ru" },
    }).then(response => response.data.data);
  }

  /**
   * Возвращает данные по обращению
   * @return Promise<any, CustomerOrderHistory>
   */
  static getOrderHistory(customerId, orderId) {
    return Http.get(`v1/customers/${customerId}/history/${orderId}`, { params: { lang: "ru" } }).then(
      response => response.data.data,
    );
  }

  /**
   * Возвращает последние значения параметров пациента
   * @param {number} customerId
   * @param {number[]} paramIds
   * @return {Promise<Array<{id: number, lval: number|string, measure: string}>>}
   */
  static getLatestParameters(customerId, paramIds) {
    return Http.get(`v1/customers/${customerId}/params/latest`, {
      params: { lang: "ru", param_ids: paramIds },
      paramsSerializer: params => {
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          if (Array.isArray(params[key])) {
            params[key].forEach(val => searchParams.append(`${key}[]`, val));
          } else {
            searchParams.append(key, params[key]);
          }
        });
        return searchParams.toString();
      },
    }).then(response => response.data.data);
  }
}
